import React, { useState } from 'react';
import axios from 'axios';
import { fehlerText } from '../lib/belegKarte';

const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

interface Props {
  vertragId: number;
  /** Vorbelegung: frühestes zulässiges Kündigungsdatum. */
  datumVorschlag: string | null;
  /** Checkbox „trotzdem (Kulanz)“ nur für Admin/Geschäftsführer. */
  kulanzErlaubt: boolean;
  onGekuendigt: () => void;
  onAbbrechen: () => void;
}

/** Dialog „Kündigen“ → POST /api/vertraege/{id}/kuendigen; ein 409 (Frist verletzt)
 *  zeigt die Meldung mit dem frühesten Datum. */
const VertragKuendigenDialog: React.FC<Props> = ({
  vertragId, datumVorschlag, kulanzErlaubt, onGekuendigt, onAbbrechen,
}) => {
  const [datum, setDatum] = useState(datumVorschlag ?? '');
  const [grund, setGrund] = useState('');
  const [trotzdem, setTrotzdem] = useState(false);
  const [speichert, setSpeichert] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);

  const kuendigen = async () => {
    setFehler(null);
    if (!datum) { setFehler('Bitte das Kündigungsdatum angeben.'); return; }
    if (!grund.trim()) { setFehler('Bitte einen Grund angeben.'); return; }
    setSpeichert(true);
    try {
      await axios.post(`${API_URL}/api/vertraege/${vertragId}/kuendigen`, {
        kuendigung_zum: datum,
        grund: grund.trim(),
        trotzdem: kulanzErlaubt && trotzdem,
      });
      onGekuendigt();
    } catch (err: unknown) {
      const detail = axios.isAxiosError(err) ? err.response?.data?.detail : undefined;
      setFehler(fehlerText(detail, 'Vertrag konnte nicht gekündigt werden.'));
    } finally {
      setSpeichert(false);
    }
  };

  return (
    <div className="aa-rechnung-dialog">
      <div className="aa-rechnung-dialog__zeile">
        <label>Kündigung zum <input type="date" value={datum} onChange={e => setDatum(e.target.value)} /></label>
        <input
          placeholder="Grund *"
          value={grund}
          onChange={e => setGrund(e.target.value)}
          style={{ flex: 1, minWidth: 200, padding: 4 }}
        />
      </div>
      {kulanzErlaubt && (
        <div className="aa-rechnung-dialog__zeile">
          <label>
            <input type="checkbox" checked={trotzdem} onChange={e => setTrotzdem(e.target.checked)} />
            {' '}trotzdem (Kulanz) — auch vor dem frühesten Kündigungsdatum
          </label>
        </div>
      )}
      {fehler && <div className="aa-inline-fehler">{fehler}</div>}
      <div className="aa-rechnung-dialog__zeile">
        <button type="button" className="k-btn k-btn--danger" onClick={kuendigen} disabled={speichert}>
          {speichert ? 'Kündigt…' : 'Kündigen'}
        </button>
        <button type="button" className="k-btn k-btn--ghost" onClick={onAbbrechen} disabled={speichert}>
          Abbrechen
        </button>
      </div>
    </div>
  );
};

export default VertragKuendigenDialog;
